import noop from "lodash.noop";
import { call, takeEvery } from "redux-saga/effects";
import {
  BACKUP_REQUESTED,
  RESET_REQUESTED,
  RESTORE_REQUESTED,
  UPDATE_AI_REQUESTED,
  backupFailed,
  backupRequested,
  backupSucceeded,
  defaultScopeId,
  resetFailed,
  resetRequested,
  resetSucceeded,
  restoreFailed,
  restoreRequested,
  restoreSucceeded,
  updateAIFailed,
  updateAIProgressed,
  updateAIRequested,
  updateAISucceeded,
} from "./data.duck";
import { backupData, resetData, restoreData, updateAIEmbeddings } from "./data.api";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import {
  getId,
  injectApiWithContextFactory,
  injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
  {
    backupRequested,
    backupSucceeded,
    backupFailed,
    restoreRequested,
    restoreSucceeded,
    restoreFailed,
    resetRequested,
    resetSucceeded,
    resetFailed,
    updateAIRequested,
    updateAISucceeded,
    updateAIFailed,
    updateAIProgressed
  },
  getId,
  defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
  {
    backupData,
    restoreData,
    resetData,
    updateAIEmbeddings,
  },
  injectBoundGQLClient
);

export function* backupDataSaga({
  api: { backupData },
  actions: { backupSucceeded, backupFailed },
  resolve = noop,
  reject = noop,
}) {
  try {
    const result = yield backupData();
    yield backupSucceeded(result);
    yield call(resolve);
  } catch (e) {
    yield backupFailed(e);
    yield call(reject, e);
  }
}

export function* restoreDataSaga({
  api: { restoreData },
  actions: { restoreSucceeded, restoreFailed },
  resolve = noop,
  reject = noop,
}) {
  try {
    const result = yield restoreData();
    yield restoreSucceeded(result);
    yield call(resolve);
  } catch (e) {
    yield restoreFailed(e);
    yield call(reject, e);
  }
}

export function* resetDataSaga({
  api: { resetData },
  actions: { resetSucceeded, resetFailed },
  resolve = noop,
  reject = noop,
}) {
  try {
    const result = yield resetData();
    yield resetSucceeded(result);
    yield call(resolve);
  } catch (e) {
    yield resetFailed(e);
    yield call(reject, e);
  }
}

export function* updateAISaga({
  api: { updateAIEmbeddings },
  actions: { updateAISucceeded, updateAIFailed, updateAIProgressed },
  resolve = noop,
  reject = noop,
  data
}) {
  try {
    const result = yield updateAIEmbeddings(data);
    while (true) {
      const progressPacket = result.progressIterator.next();
      if (progressPacket.done) break;
      const progressResult = yield progressPacket.value;
      yield updateAIProgressed(progressResult);
    }
    yield updateAISucceeded(result);
    yield call(resolve);
  } catch (e) {
    yield updateAIFailed(e);
    yield call(reject, e);
  }
}

export default () =>
  function* rootSaga() {
    yield takeEvery(
      BACKUP_REQUESTED,
      withApiContext(withBoundActions(backupDataSaga))
    );
    yield takeEvery(
      RESTORE_REQUESTED,
      withApiContext(withBoundActions(restoreDataSaga))
    );
    yield takeEvery(
      RESET_REQUESTED,
      withApiContext(withBoundActions(resetDataSaga))
    );
    yield takeEvery(
      UPDATE_AI_REQUESTED,
      withApiContext(withBoundActions(updateAISaga))
    );
  };
